import React from 'react';
import Services from '../layout/Services';

export default function Sluzby() {
  return (
    <div>
      <Services />
    </div>
  );
}
